export const SORTING = {
  bestMatch: {
    value: 'bestMatch',
    key: 'search.filter_header.sorting.best_match'
  },
  bestPrice: {
    value: 'bestPrice',
    key: 'search.filter_header.sorting.best_price'
  },
  recentlyListed: {
    value: 'recentlyListed',
    key: 'search.filter_header.sorting.recently_published'
  }
};

export const HIDDEN_SORTING = {
  POI: {
    value: 'POI',
    key: 'search.filter_header.sort_by_distance'
  }
};

export const DEFAULT_SORTING = SORTING.bestMatch.value;

export const DEFAULT_FILTERS = {
  'move-in': '',
  'move-out': '',
  flexibleMoveIn: 1,
  flexibleMoveOut: 1,
  'features[]': [],
  'type[]': [],
  'topology[]': [],
  'bathrooms[]': [],
  bed: '',
  budget: '',
  poi: '',
  sortBy: DEFAULT_SORTING,
  noDeposit: 0,
  instantBooking: 0,
  superLister: 0,
  plan: '',
  verified: 0,
  'ids[]': [],
  'areaId[]': [],
  page: 1,
  poiLat: null,
  poiLng: null
};

export const DEFAULT_FILTERS_TRANSLATED = Object.entries(
  DEFAULT_FILTERS
).reduce(
  (acc, [name, value]) => ({
    ...acc,
    [name.replace('[]', '')]: value
  }),
  {}
);

const {
  sortBy: DEFAULT_SORT_BY,
  ...restDefaultFilters
} = DEFAULT_FILTERS_TRANSLATED;

export const DEFAULT_FILTERS_TRANSLATED_NO_SORT = restDefaultFilters;

export default {
  SORTING,
  HIDDEN_SORTING,
  DEFAULT_SORTING,
  DEFAULT_FILTERS,
  DEFAULT_FILTERS_TRANSLATED,
  DEFAULT_FILTERS_TRANSLATED_NO_SORT
};
